import { colors } from '../../colors';
var accordion = {
  bodyBackgroundColor: colors.alabaster,
  iconColor: colors.pine,
  rowBackgroundColor: colors.overcast,
  textColorDark: colors.ash,
  textColorLight: colors.white
};
export default accordion;